@use "@fukuri-admins/ui/layout" as *;

.screen {
  @include screen;
}

.content {
  @include content;
}

.body {
  @include body;
}

.BannerWrapper {
  position: fixed;
  bottom: spacing('24');
  right: spacing('24');
}
